type MedicineDetailsTextContentProps = {
   readonly text: string | number;
};

const MedicineDetailsTextContent = (props: MedicineDetailsTextContentProps): JSX.Element => {
   return <div>{props.text}</div>;
};

export { MedicineDetailsTextContent };
